import { useSelector } from 'react-redux';
import ThreadListMembersSidebar from './ThreadListMembersSidebar';
import SearchResultsContainer from '../../thread-search-and-filtering/components/SearchResultsContainer';
import { isInSearchAndFilterMode as getIsInSearchAndFilterMode } from 'conversations-inbox-lib/thread-search-and-filtering/public/selectors';
import { selectHasFiltersSet } from 'find-and-filter-data/search-and-filter-data/protected';
import FilterOptionsBarContainer from './FilterOptionsBarContainer';
import ThreadListMemberSidebarFrame from './ThreadListMemberSidebarFrame';
import DetailHeaderWrapper from '../../unified-inbox/components/DetailHeaderWrapper';
import DisplayResultsText from './DisplayResultsText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadListMembersSidebarWrapper = ({
  threadId
}) => {
  const hasFiltersSet = useSelector(selectHasFiltersSet);
  const isInSearchAndFilterMode = useSelector(getIsInSearchAndFilterMode);
  const getContent = () => {
    if (isInSearchAndFilterMode) {
      if (hasFiltersSet) {
        return /*#__PURE__*/_jsx(SearchResultsContainer, {
          threadId: threadId
        });
      }
      return /*#__PURE__*/_jsx(DisplayResultsText, {
        message: "conversations-inbox-ui.thread-search-and-filtering.thread-list-member-sidebar.zeroState"
      });
    }
    return /*#__PURE__*/_jsx(ThreadListMembersSidebar, {
      focusedThreadId: threadId
    });
  };
  return /*#__PURE__*/_jsxs(ThreadListMemberSidebarFrame, {
    children: [/*#__PURE__*/_jsx(DetailHeaderWrapper, {
      className: "p-x-1 justify-between align-center",
      children: /*#__PURE__*/_jsx(FilterOptionsBarContainer, {})
    }), getContent()]
  });
};
ThreadListMembersSidebarWrapper.displayName = 'ThreadListMembersSidebarWrapper';
export default ThreadListMembersSidebarWrapper;